<template>
	<UIHeader dark>
		<div class="flex flex-col items-center">
			<h1
				class="mx-auto mb-1 max-w-xl text-center text-2xl leading-none font-black text-neutral-100 sm:text-4xl! md:text-5xl! lg:text-7xl!"
			>
				Propeller Festival
			</h1>
			<h2
				class="my-0 text-center text-xs wrap-break-word text-neutral-400 sm:text-base md:text-lg dark:text-neutral-400"
			>
				wir sagen Danke für dein Ehrenamt
			</h2>
			<p
				class="mb-4 text-xs text-neutral-400 sm:mb-8 sm:text-base md:text-lg dark:text-neutral-400"
			>
				Wangen im Allgäu
			</p>
			<!-- <UICounttdown :goalTime="festivalDate!.start_date" class="mb-32" /> -->
			<UButton
				color="secondary"
				class="xs:text-base px-4 text-sm font-semibold tracking-wider uppercase lg:px-12 lg:text-lg"
				disabled
				@click="toTickets"
			>
				<!-- Jetzt Tickets sichern! -->
				Es ist vorbei!
			</UButton>
			<!-- <p class="text-center text-sm text-neutral-200 sm:text-base">
				wird am
				<b>12./13.</b>
				Juli 2025 zurückkommen
			</p> -->
		</div>
	</UIHeader>
	<main>
		<div class="py-8">
			<HomeKulturNight />
			<!-- <HomeFestivalNight class="mb-6" /> -->
			<!-- <HomeLastDay class="mb-20" /> -->
			<UIWaveSeparator background-color="darkRed" class="mb-6" />
			<HomeAftermovies class="mb-20" />
			<!-- <HomeTheWeTheFestival class="mb-20" /> -->
			<!-- <UIWaveSeparator background-color="brightestGreen" class="mb-20" /> -->
			<!-- <SharedDownloads ref="downloads" class="container mb-20" /> -->
		</div>
	</main>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Startseite',
	ogTitle: 'Startseite',
	twitterTitle: 'Startseite',
	description:
		'Das Propellerfestival ist ein Dankeschön in Form eines Musikfestivals für junge Menschen ab 16 Jahren, die sich ehrenamtlich engagieren. Euch erwarten andere Ehrenamtliche, gutes Essen und richtig gute Musik mit Bands und einem DJ.',
	ogDescription:
		'Das Propellerfestival ist ein Dankeschön in Form eines Musikfestivals für junge Menschen ab 16 Jahren, die sich ehrenamtlich engagieren. Euch erwarten andere Ehrenamtliche, gutes Essen und richtig gute Musik mit Bands und einem DJ.',
	twitterDescription:
		'Das Propellerfestival ist ein Dankeschön in Form eines Musikfestivals für junge Menschen ab 16 Jahren, die sich ehrenamtlich engagieren. Euch erwarten andere Ehrenamtliche, gutes Essen und richtig gute Musik mit Bands und einem DJ.',
	ogUrl: 'https://propellerfestival.de',
})

const downloadsRef = useTemplateRef('downloads')

const scrollToDownloads = () => {
	nextTick(() => {
		// Scroll to the downloads section if the hash is present
		setTimeout(() => {
			if (downloadsRef.value) {
				downloadsRef.value.$el.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				})
			}
		}, 300)
	})
}

const routeHash = computed(() => useRoute().hash)

// Watch for route changes to handle client-side navigation
watch(
	() => routeHash,
	(newHash) => {
		if (newHash.value === '#downloads') {
			scrollToDownloads()
		}
	},
	{ immediate: true }
)

async function toTickets() {
	// Track the event
	umTrackEvent('nav_to_ticket', {
		category: 'navigation',
		action: 'nav_to_ticket',
		label: 'navigate to the ticket page',
	})
	await navigateTo('/ticket')
}
</script>
